import React from 'react';

const cardStyle = {
  maxWidth: 360,
  margin: '40px auto',
  padding: 32,
  border: '1px solid #ccc',
  borderRadius: 10,
  background: '#f7fafd',
  boxShadow: '0 2px 12px #0001',
  textAlign: 'center'
};

/**
 * 指挥页登录 / 密码门禁
 * 验证过程中始终保留输入框，避免「整页加载」造成卡死感。
 */
export default function DashboardAuthGate({
  mode, // 'login' | 'password'
  loadingPwd = false,
  verifying = false,
  inputPwd = '',
  pwdError = '',
  onInputPwdChange,
  onCheckPwd
}) {
  if (mode === 'login') {
    return (
      <div style={cardStyle}>
        <h2 style={{ marginBottom: 24, color: '#1976d2' }}>指挥系统 - 登录验证</h2>
        <div style={{ color: '#888', fontSize: 14, marginBottom: 20 }}>
          请先登录系统后再访问指挥系统页面
        </div>
        <button
          type="button"
          onClick={() => { window.location.href = '/login'; }}
          style={{
            width: 200,
            height: 36,
            background: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            fontSize: 16,
            fontWeight: 600,
            cursor: 'pointer'
          }}
        >
          前往登录
        </button>
      </div>
    );
  }

  const busy = verifying;
  const statusHint = verifying
    ? '正在验证…'
    : (loadingPwd ? '正在检查口令配置…' : '');

  return (
    <div style={cardStyle}>
      <h2 style={{ marginBottom: 24, color: '#1976d2' }}>指挥系统 - 密码验证</h2>
      <input
        type="password"
        value={inputPwd}
        disabled={busy}
        onChange={(e) => onInputPwdChange?.(e.target.value)}
        placeholder="请输入访问密码"
        autoFocus
        style={{
          width: 200,
          height: 36,
          fontSize: 16,
          borderRadius: 6,
          border: '1px solid #bbb',
          padding: '0 12px',
          marginBottom: 12,
          opacity: busy ? 0.7 : 1
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !busy) onCheckPwd?.();
        }}
      />
      <br />
      <button
        type="button"
        onClick={onCheckPwd}
        disabled={busy || !String(inputPwd || '').trim()}
        style={{
          width: 200,
          height: 36,
          background: busy ? '#90caf9' : '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          fontSize: 16,
          fontWeight: 600,
          cursor: busy ? 'wait' : 'pointer',
          marginBottom: 8
        }}
      >
        {verifying ? '验证中…' : '验证'}
      </button>
      <div style={{ color: '#888', fontSize: 13, minHeight: 18, marginBottom: 4 }}>
        {statusHint}
      </div>
      <div style={{ color: 'red', marginTop: 2, minHeight: 20 }}>
        {pwdError || ''}
      </div>
      <div style={{ color: '#888', fontSize: 13, marginTop: 18 }}>
        本页面仅限授权人员访问，请输入密码
      </div>
    </div>
  );
}
